// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2MARr","content":"styles_content__3xbWi","checkbox":"styles_checkbox__ua3Ww","checkboxLabel":"styles_checkboxLabel__3Iyjm"};